<template>
  <main class="main" role="main">
    <div class="main__inner bg"><!-- 배경: bg-->
      <div class="main__con">
        <div class="p16">
          <div class="complete m36">
            <p class="complete__txt"><span class="primary">제공중인 서비스</span></p>
            <p class="complete__txt__small" style="margin-top: 1rem;">
              서비스를 선택해주세요.<br>
            </p>
          </div>
          <div class="btn m26">
            <button class="left" @click="moveElect()">전력비 절감</button>
          </div>
          <div class="btn m26">
            <button class="left" @click="moveLabor()">노무 지원</button>
          </div>
          <div class="btn m26">
            <button class="left" @click="moveCert()">인증 지원</button>
          </div>
          <div class="btn m26">
            <button class="left" @click="moveLab()">연구소 관리</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      electData: {},
      laborData: {},
      labData: {},
    }
  },
  created: async function () {
    await this.getSerivceStatus();
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  methods: {
    getSerivceStatus: async function () {
      const params = {userNo: this.userData.userNo}
      const res = await this.$MainSvc.getServiceStatus(params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      // console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.electData = entity.electData
        this.laborData = entity.laborData
        this.labData = entity.labData
      }
    },
    moveElect: function () {
      if (this.$Util.isEmpty(this.electData)) {
        this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.CONFIRM, {message: '현재 전력비 절감 서비스를 이용중이지 않습니다.<br>문의하기 페이지로 이동하시겠습니까?'}, () => {
          setTimeout(() => {
            this.$router.replace('/main/message')
          }, 100)
        })
      } else {
        this.$router.push(this.electData.serviceStatus === 100 ? '/main/report' : '/main/progress')
      }
    },
    moveLabor: function () {
      this.$Util.modalAlert({message: '현재 서비스 준비중입니다.'})
    },
    moveCert: function () {
      if (this.userData.isCert === 1) {
        this.$router.push('/cert')
      } else {
        this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.CONFIRM, {message: '현재 인증 서비스를 이용중이지 않습니다.<br>문의하기 페이지로 이동하시겠습니까?'}, () => {
          setTimeout(() => {
            this.$router.replace('/main/message')
          }, 100)
        })
      }
    },
    moveLab: function () {
      if (this.userData.isLab === 1) {
        this.$router.push('/lab')
      } else {
        this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.CONFIRM, {message: '현재 연구소 서비스를 이용중이지 않습니다.<br>문의하기 페이지로 이동하시겠습니까?'}, () => {
          setTimeout(() => {
            this.$router.replace('/main/message')
          }, 100)
        })
      }
    }
  }
}
</script>

<style scoped></style>
